var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_118_30809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00261 1.33203L8.21861 1.33536C9.96709 1.39205 11.6232 2.13373 12.8298 3.40044C14.0364 4.66715 14.6967 6.35737 14.6684 8.10654C14.6401 9.85572 13.9253 11.5237 12.6783 12.7506C11.4313 13.9776 9.75201 14.6652 8.00261 14.6652C6.2532 14.6652 4.5739 13.9776 3.3269 12.7506C2.07991 11.5237 1.36516 9.85572 1.33681 8.10654C1.30847 6.35737 1.96881 4.66715 3.17539 3.40044C4.38198 2.13373 6.03812 1.39205 7.78661 1.33536L8.00261 1.33203ZM8.41127 4.80536C8.27728 4.70176 8.10887 4.65304 7.94026 4.6691C7.77164 4.68516 7.61546 4.7648 7.50344 4.89185C7.39142 5.01889 7.33195 5.18381 7.33712 5.35311C7.34229 5.52241 7.41171 5.68339 7.53127 5.80336L9.05861 7.33203H5.33594L5.25794 7.3367C5.08921 7.35677 4.93451 7.44051 4.82545 7.57081C4.71639 7.70111 4.6612 7.86814 4.67116 8.03777C4.68112 8.2074 4.75547 8.36682 4.87903 8.48347C5.00258 8.60011 5.16602 8.66518 5.33594 8.66536H9.05861L7.53127 10.194L7.47594 10.2567C7.37233 10.3907 7.32361 10.5591 7.33967 10.7277C7.35574 10.8963 7.43538 11.0525 7.56242 11.1645C7.68946 11.2766 7.85438 11.336 8.02368 11.3308C8.19298 11.3257 8.35397 11.2563 8.47394 11.1367L11.1406 8.47003L11.1893 8.41536L11.2319 8.35603L11.2733 8.2807L11.3026 8.20736L11.3226 8.1327L11.3339 8.0487L11.3359 7.9987L11.3313 7.92003L11.3119 7.82136L11.2886 7.75136L11.2526 7.67603L11.2053 7.60203C11.1856 7.57559 11.164 7.55063 11.1406 7.52736L8.47394 4.8607L8.41127 4.80536Z",
    fill: "#798399"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_30809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowNext);
export default __webpack_public_path__ + "static/media/icon-arrow-next.da662124d8cd7c6baa40bfbd0094a9ef.svg";
export { ForwardRef as ReactComponent };